import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppSharedModule } from '../../app-shared.module';
import { GroupPermissionTableComponent } from './components/permission-table/group-permission-table.component';
import { UserPermissionTableComponent } from './components/permission-table/user-permission-table.component';

@NgModule({
  declarations: [GroupPermissionTableComponent, UserPermissionTableComponent],
  imports: [AppSharedModule],
  exports: [GroupPermissionTableComponent, UserPermissionTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GroupSharedModule {}
